import { ApplicationUser } from '../../src/entities/ApplicationUser';
import { WebClient } from './server/WebClient';

export const AdminService = {
    stopImpersonation: () => WebClient.Get<ApplicationUser>("api/Admin/StopImpersonation"),

    cancelAndRefundMakerSubscription: () => WebClient.Put.Validated<ApplicationUser>("api/Admin/CancelAndRefundMakerSubscription", {})
}
